export default __webpack_public_path__ + "static/media/main-logo.6729b3db.webp";